import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Card, CardContent, Grid, IconButton, Radio, Typography } from '@mui/material';
import { useContext } from 'react';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { EditIcon } from '../../images/svg/CustomizedSVG';

const customRadioClasses = {
  radioStyles: {
    '&.Mui-checked': {
      color: '#661C69',
    },
    '&.Mui-disabled': {
      color: '#979797',
    },
  },
  radioRoot: {
    color: '#661C69',
  },
};

const AddressCard = ({
  id,
  getValue,
  selected,
  address,
  customerName,
  isBundle,
  // isNewAddress,
  handleToggleSwitchAddress,
}) => {
  const { t } = useTranslation();
  const handleCardClick = (e) => {
    getValue(address);
  };

  const handleInputChange = (e) => {
    if (e.key === 'Enter') {
      getValue(address);
    }
  };
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme } = leadGenerationContext;
  return (
    <Card
      elevation={isBundle ? 0 : 1}
      style={
        isBundle
          ? {
              position: 'relative',
              cursor: 'pointer',
              borderRadius: '6px',
              display: 'flex',
              padding: '15px',
              marginBottom: '12px',
              alignItems: 'center',
              backgroundColor: theme?.palette?.fieldsBackground?.main,
              border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
              color: theme?.palette?.errorSubtext?.main,
            }
          : {
              position: 'relative',
              cursor: 'pointer',
              border: '1px solid #D0D0D0',
              boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.21)',
              borderRadius: '6px',
              display: 'flex',
              padding: '15px',
              marginBottom: '12px',
              alignItems: 'center',
            }
      }
      onClick={handleCardClick}
      data-testid="addressCard_testId"
    >
      <Grid container width="100%">
        <Grid size={{ md: 11, lg: 11, sm: 11, xs: 11 }} display="flex" alignItems="center">
          {!isBundle && (
            <Radio
              size="small"
              style={{
                padding: 0,
              }}
              sx={customRadioClasses.radioStyles}
              classes={{ root: customRadioClasses.radioRoot }}
              checked={selected === id}
              onChange={handleInputChange}
              onKeyDown={handleInputChange}
              inputProps={{
                'data-testid': `${customerName}_testid`,
              }}
              id={id}
            />
          )}
          <CardContent style={{ padding: '0px 0px 0px 10px' }}>
            <Typography style={{ font: 'normal 400 14px/normal Arial' }}>
              {address?.LineOne ? `${address?.LineOne}, ` : ''}
              {address?.LineTwo ? `${address?.LineTwo}, ` : ''}
              {address?.AddrCity ? `${address?.AddrCity}, ` : ''}
              {address?.AddrState ? `${address?.AddrState} ` : ''}
              {address?.ZipCode ? `${address?.ZipCode}.  ` : ''}
              {address?.AddrCountry ? `${address?.AddrCountry}.` : ''}
            </Typography>
          </CardContent>
        </Grid>
        <Grid size={{ md: 1, lg: 1, sm: 1, xs: 1 }}>
          {isBundle && (
            // <InputAdornment position="end">
            <IconButton
              onClick={handleToggleSwitchAddress}
              edge="end"
              sx={{ float: 'right' }}
              data-testid="Edit Icon"
              aria-label={t('Edit', { defaultValue: 'Edit' })}
            >
              <EditIcon color={theme?.palette?.orientalPrimary?.main} />
            </IconButton>

            // </InputAdornment>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default AddressCard;

AddressCard.propTypes = {
  id: PropTypes.string,
  customerName: PropTypes.string,
  getValue: PropTypes.func,
  handleToggleSwitchAddress: PropTypes.func,
  selected: PropTypes.string,
  address: PropTypes.object,
  isBundle: PropTypes.bool,
};
